import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7xmwfhpnh9: FaireBrandEntity = {
  token: "b_7xmwfhpnh9",
  type: "brand",
  name: "AG Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/65c4bbb112086c73a8edf772de971fc25c7afecfdb8434482acd5ff713fa6da6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/19abca6d42b02246a85320bb9a141659f9f2e15ef4eb2260c37c443108bc83a1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/65c4bbb112086c73a8edf772de971fc25c7afecfdb8434482acd5ff713fa6da6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/19abca6d42b02246a85320bb9a141659f9f2e15ef4eb2260c37c443108bc83a1.jpeg",
  location: "Laguna Niguel, CA, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "AG Studio Dresses is one of the largest suppliers of wholesale dresses and women's apparel. We pride ourselves on bringing customers an amazing assortment of dresses perfect for every occasion, from party and prom to cocktail events. Our online store caters to customers looking for stylish and affordable dresses, with a wide selection ranging from bridal dresses and long evening gowns to short evening dresses, cocktail dresses, and jumpsuits. At AG Studio Dresses, we are committed to providing quality apparel and exceptional customer service to meet all your wholesale needs.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:42.421Z",
    importedBy: "entity-db-cli",
  },
};
